import { Controller } from "@hotwired/stimulus";
import { Modal } from "bootstrap";

export default class extends Controller {
  static values = { streamId: String, backdrop: String };

  connect() {
    const options = { backdrop: true };
    if (this.hasBackdropValue) {
      switch (this.backdropValue.toLowerCase()) {
        case "false":
          options.backdrop = false;
          break;
        case "static":
          options.backdrop = "static";
          break;
      }
    }

    this.modal = Modal.getOrCreateInstance(this.element, options);

    if (this.hasStreamIdValue) {
      this.cleanupController = new AbortController();
      const signal = this.cleanupController.signal;
      const streamId = this.streamIdValue;
      document.addEventListener(
        "turbo:before-stream-render",
        (event) => {
          if (event.target.target === streamId) {
            this.open();
          }
        },
        { signal },
      );

      this.element.addEventListener(
        "hidden.bs.modal",
        (_event) => {
          this.element.querySelectorAll("div").forEach((element) => {
            if (element.id === streamId) {
              element.innerHTML = "";
            }
          });
        },
        { signal },
      );
    }
  }

  disconnect() {
    super.disconnect();
    if (this.cleanupController) {
      this.cleanupController.abort();
    }
  }

  open() {
    if (this.modal.isOpened) return;

    this.closeAllOtherModals();
    this.modal.show();
    this.focusFirstUserInput();
  }

  closeAllOtherModals() {
    document
      .querySelectorAll('[data-controller="modal"]')
      .forEach((modalEl) => {
        const modalInstance = Modal.getInstance(modalEl);
        if (modalInstance && modalInstance !== this.modal) {
          // Close the modal
          modalInstance.hide();

          // Throw away all forms in the modal
          modalEl
            .querySelectorAll("form")
            .forEach((modalForms) => modalForms.remove());
        }
      });
  }

  focusFirstUserInput() {
    // Wait for the modal to be fully shown to set focus
    this.modal._element.addEventListener(
      "shown.bs.modal",
      () => {
        const inputs = this.element.querySelectorAll("input, textarea, select");
        const firstUserInput = Array.from(inputs).find(
          (input) =>
            input.type !== "hidden" &&
            input.style.display !== "none" &&
            input.style.visibility !== "hidden" &&
            !input.disabled,
        );
        if (firstUserInput) {
          firstUserInput.focus();
        }
      },
      { once: true },
    ); // Ensure the event listener is only used once
  }

  close(event) {
    if (!event.detail.success) {
      return;
    }
    this.modal.hide();
  }
}
